//WMS - 入库管理api
import {ServerDistApi, ServerNoDistApi} from '@/group-cloud/network/ServerBizApi';

//配置下拉框值集
export const All_Sel_Option = 'all';
//库存状态
export const Mod_StockStatus_Types = {
    ZERO: 0,  //待确认
    ONE:  1,  //已确认
    TWO:  2,  //已出库
    THREE: 3, //异常
    FOUR: 4, //已取消
}

export const Mod_StockStatus_Options = [
    {id: All_Sel_Option, label: '全部'}, 
    {id: Mod_StockStatus_Types.ZERO, label: '待确认'},      
    {id: Mod_StockStatus_Types.ONE, label: '已确认'},   
    {id: Mod_StockStatus_Types.TWO, label: '已出库'},   
    {id: Mod_StockStatus_Types.FOUR, label: '已取消'},
    {id: Mod_StockStatus_Types.THREE, label: '异常'},   
];
export class WmsWarehousingApi {

    constructor() {
    }
    protected static groupUrl = '/wms/bill/out';
    // https://api.pre.mzdata.top/data-dist/api/dist/wms/bill/out/list

    //出库单列表查询
    public static async getBillList(data) {
        let uri = this.groupUrl + '/list';
        return await ServerDistApi.send(uri, data);
    }

    //出库单确认出库
    public static async sureOutput(data) {
        let uri = this.groupUrl + '/confirm';
        return await ServerDistApi.get(uri, data);
    }

    //出库单取消出库
    public static async cancelOutput(data) {
        let uri = this.groupUrl + '/cancel';
        return await ServerDistApi.get(uri, data);
    }

    //保存出库单
    public static async saveBill(data) {
        let uri = this.groupUrl + '/save';
        return await ServerDistApi.send(uri, data);
    }

    //获取单个出库单
    public static async oneBill(data) {
        let uri = this.groupUrl + '/get';
        return await ServerDistApi.get(uri, data);
    }

    //取消出库单
    // public static async cancelBill(data) {
    //     let uri = this.groupUrl + '/cancel';
    //     return await ServerDistApi.send(uri, data);
    // }

    //删除出库单
    public static async deleteBill(data){
        let uri = this.groupUrl + '/delete';
        return await ServerDistApi.get(uri, data);
    }

    //仓位添加
    public static async saveLoc(data) {
        let uri = this.groupUrl + '/loc/save';
        return await ServerDistApi.send(uri, data);
    }
    
    //获取仓位
    public static async getLocList(data) {
        let uri = this.groupUrl + '/loc/list';
        return await ServerDistApi.send(uri, data);
    }
    
    //获取一个仓位信息
    public static async oneLocList(data) {
        let uri = this.groupUrl + '/loc/get';
        return await ServerDistApi.get(uri, data);
    }

    //下载
    public static async downLoad(data) {
      let uri = this.groupUrl + '/export';
      return await ServerDistApi.send(uri, data);
  }

    //获取主体
    public static async getAllMainBody(data){
        let url = '/main/account/configuration/selectList';
        return await ServerNoDistApi.get(url, data);
    }
}


